<template>
  <div class="item-selector">
      <div v-if="item.item_id" class="selected-item">
        {{ item.name }}

        <!-- <span class="deselect-icon" @click="deselectItem(item, index)">
          <font-awesome-icon icon="times-circle" />
        </span> -->
      </div>
      <base-select
        v-else
        ref="baseSelect"
        v-model="itemSelect"
        :options="itemOptions"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.name"
        :invalid="invalid"
        :placeholder="$t('invoices.item.select_an_item')"
        label="name"
        class="multi-select-item"
        @value="onTextChange"
        @select="(val) => $emit('select', val)"
      >
      </base-select>
      <div class="item-description">
        <base-text-area
          v-autoresize
          v-model="item.description"
          :invalid-description="invalidDescription"
          :placeholder="$t('invoices.item.type_item_description')"
          type="text"
          rows="1"
          class="description-input"
          @input="$emit('onDesriptionInput')"
        />
        <div v-if="invalidDescription">
          <span class="text-danger">{{ $tc('validation.description_maxlength') }}</span>
        </div>
        <!-- <textarea type="text" v-autoresize rows="1" class="description-input" v-model="item.description" placeholder="Type Item Description (optional)" /> -->
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: null
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidDescription: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      itemSelect: null,
      loading: false,
      type:'',
      addItemButtonShow:true,
      itemOptions:[]
    }
  },
  computed: {
    ...mapGetters('deliveryNote', [
      'POItems',
      'POHasItems',
      'deliveryNoteItems',
      'availableDeliveryNoteItems',
      'deliveryNoteItemsStatus'
    ]),
    ...mapGetters('item', [
      'items'
    ]),
  },
  watch: {
    invalidDescription (newValue) {
    }
  },
  created(){
    this.deliveryNoteType();
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('item', [
      'fetchItems'
    ]),
    async deliveryNoteType(){
      if (this.$route.name === 'delivery-notes.edit') {
        if(this.POHasItems == true && this.deliveryNoteItemsStatus== true){
          console.log('po')
          if(this.POItems){
            console.log('po')
            this.itemOptions = this.POItems
          }
        }else if(this.POHasItems == false  && this.deliveryNoteItemsStatus ==true ){
          console.log('else if')
          console.log(this.availableDeliveryNoteItems)
          this.itemOptions = this.availableDeliveryNoteItems
        }else{
           console.log('else')
          this.itemOptions = this.availableDeliveryNoteItems
        }
      }
    },
    async searchItems (search) {
      let data = {
        filter: {
          name: search,
          price: ''
        },
        orderByField: '',
        orderBy: '',
        page: 1
      }

      this.loading = true
      if (this.$route.name === 'delivery-notes.edit' && this.deliveryNoteItems) {
      }else if(this.$route.name === 'delivery-notes.edit' && this.deliveryNoteItems){
        await this.fetchItems(data)
      }

      this.loading = false
    },
    onTextChange (val) {
      this.searchItems(val)

      this.$emit('search', val)
    },
    openItemModal () {
      this.$emit('onSelectItem')
      this.openModal({
        'title': 'Add Item',
        'componentName': 'ItemModal',
        'data': {taxPerItem: this.taxPerItem, taxes: this.taxes}
      })
    },
    deselectItem(item, index) {
      this.itemSelect = null
      this.$emit('deselect', item, index)
    }
  }
}
</script>
